// extracted by mini-css-extract-plugin
export var brand = "_a3-9";
export var compact = "_a3-6";
export var extraSmall = "_a3-7";
export var icon = "_a3-0";
export var large = "_a3-4";
export var light = "_a3-1";
export var medium = "_a3-5";
export var outline = "_a3-b";
export var primaryDark = "_a3-a";
export var primaryLight = "_a3-8";
export var primaryModern = "_a3-c";
export var success = "_a3-2";
export var successSolid = "_a3-3";